import * as React from 'react';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import LegacyDispatcher from 'app/lib/legacyDispatcher';
import BuildRow from 'app/components/build/Row';

/* eslint-disable react/prefer-es6-class */
// TODO: Move to a class

export default createReactClass({
  displayName: 'BranchListBranch',

  propTypes: {
    branch: PropTypes.shape({
      starred: PropTypes.bool,
      name: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired,
      builds: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string.isRequired
        }).isRequired
      ).isRequired
    }).isRequired,
    project: PropTypes.shape({
      id: PropTypes.string.isRequired,
      permissions: PropTypes.shape({
        edit: PropTypes.shape({
          allowed: PropTypes.bool.isRequired
        }).isRequired,
        favoriteProject: PropTypes.shape({
          allowed: PropTypes.bool.isRequired
        }).isRequired
      }).isRequired
    }).isRequired
  },

  render() {
    const starredClassName = (
      this.props.branch.starred
        ? 'better-branch-starred'
        : 'better-branch-not-starred'
    );

    return (
      <div
        className={`panel panel-default better-branch-panel ${starredClassName}`}
        data-branch={this.props.branch.name}
      >
        <div className="panel-heading flex items-center">
          <div className="flex-auto">
            <h2 className="h4 m0 regular">
              <i className="fa fa-code-fork text-muted mr1" />
              <a
                className="no-highlight-link better-branch-panel-name"
                href={this.props.branch.path}
              >
                {this.props.branch.name}
              </a>
            </h2>
          </div>
          <div className="flex">
            {this.renderStarButton()}
            {this.renderRemoveButton()}
          </div>
        </div>
        {this.props.branch.builds.map(
          (build) => <BuildRow key={build.id} {...build} />
        )}
      </div>
    );
  },

  renderStarButton() {
    if (this.props.project.permissions.favoriteProject.allowed) {
      if (this.props.branch.starred) {
        return (
          <a
            href="#"
            onClick={this.handleUnstarClick}
            className="better-branch-star-button"
            aria-label={`Favorite ${this.props.branch.name} branch`}
          >
            <i className="fa fa-star" />
          </a>
        );
      }
      return (
        <a
          href="#"
          onClick={this.handleStarClick}
          className="better-branch-star-button"
          aria-label={`Favorite ${this.props.branch.name} branch`}
        >
          <i className="fa fa-star-o" />
        </a>
      );
    }

    return null;
  },

  renderRemoveButton() {
    if (this.props.project.permissions.edit.allowed) {
      return (
        <a
          href="#"
          onClick={this.handleRemoveClick}
          className="better-branch-remove-button"
          aria-label={`Remove ${this.props.branch.name} branch`}
        >
          <i className="fa fa-ban" />
        </a>
      );
    }
  },

  handleStarClick(evt) {
    evt.preventDefault();

    LegacyDispatcher.emit("project_branch:star", {
      project: this.props.project,
      branch: this.props.branch.name
    });
  },

  handleUnstarClick(evt) {
    evt.preventDefault();

    LegacyDispatcher.emit("project_branch:unstar", {
      project: this.props.project,
      branch: this.props.branch.name
    });
  },

  handleRemoveClick(evt) {
    evt.preventDefault();

    if (confirm("Remove this branch until new builds are pushed?")) {
      return LegacyDispatcher.emit("project_branch:remove", {
        projectId: this.props.project.id,
        branch: this.props.branch.name
      });
    }
  }
});
